module.exports = __webpack_public_path__ + "static/media/Laugo_06.cf9e0a88.jpg";